import { Logger, ELogEnvironment, ELogType } from 'Shared/utils/logger/logger';
export { ELogEnvironment, ELogType };
export const logger = new Logger(ELogEnvironment.Development);
